import { PluginReview } from 'rwl-shared/dist/models/plugin/Plugin';
import styled from 'styled-components6';
import { Subtitle1, Body1 } from '../../../theme';

export const ReviewAuthorContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: var(--rwl-spacing-sm) 0;
`;

export const ReviewAuthorAvatar = styled.img<{
    size: 'small' | 'large';
}>`
    margin: var(--rwl-spacing-sm);
    width: ${(props) => (props.size === 'small' ? 32 : 42)}px;
    height: ${(props) => (props.size === 'small' ? 32 : 42)}px;
    object-fit: cover;
    border-radius: 21px;
`;

export const ReviewAuthorNameContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

export const ReviewAuthor = ({ review }: { review: PluginReview }) => {
    return (
        <ReviewAuthorContainer>
            {review.authorPhotoUrl && (
                <ReviewAuthorAvatar
                    size={'large'}
                    src={review.authorPhotoUrl}
                />
            )}
            <ReviewAuthorNameContainer>
                <Subtitle1>{review.author}</Subtitle1>
                <Body1>Homeowner</Body1>
            </ReviewAuthorNameContainer>
        </ReviewAuthorContainer>
    );
};
